var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttachment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "toolbar",
    transform: "translate(-321.000000, -20.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "attachment-24px",
    transform: "translate(319.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33333333,8.33333333 C1.33333333,6.30666667 2.97333333,4.66666667 5,4.66666667 L12,4.66666667 C13.4733333,4.66666667 14.6666667,5.86 14.6666667,7.33333333 C14.6666667,8.80666667 13.4733333,10 12,10 L6.33333333,10 C5.41333333,10 4.66666667,9.25333333 4.66666667,8.33333333 C4.66666667,7.41333333 5.41333333,6.66666667 6.33333333,6.66666667 L11.3333333,6.66666667 L11.3333333,8 L6.27333333,8 C5.90666667,8 5.90666667,8.66666667 6.27333333,8.66666667 L12,8.66666667 C12.7333333,8.66666667 13.3333333,8.06666667 13.3333333,7.33333333 C13.3333333,6.6 12.7333333,6 12,6 L5,6 C3.71333333,6 2.66666667,7.04666667 2.66666667,8.33333333 C2.66666667,9.62 3.71333333,10.6666667 5,10.6666667 L11.3333333,10.6666667 L11.3333333,12 L5,12 C2.97333333,12 1.33333333,10.36 1.33333333,8.33333333 Z",
    id: "attachment",
    transform: "translate(8.000000, 8.333333) rotate(-45.000000) translate(-8.000000, -8.333333) "
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.630f2280.svg";
export { ForwardRef as ReactComponent };